import { getToken } from '../../utils/AzureADB2C';

export const GetAllPersonsAsAdminFromPortal = (filter, sorting, pageSize, pageNumber) => {

  const data = {
    filter: filter,
    sorting: sorting,
  }

  const req = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + getToken()
    },
    body: JSON.stringify(data)
  };

  const queryParam = `?pageSize=${pageSize || ""}&pageNumber=${pageNumber || ""}`

  let url = [process.env.REACT_APP_PORTAL_URL, 'person', 'getallinfo'].join('/') + queryParam;
  return fetch(url, req);
}
